import { render, staticRenderFns } from "./SimpleAlert.vue?vue&type=template&id=135c83f6&"
import script from "./SimpleAlert.vue?vue&type=script&lang=js&"
export * from "./SimpleAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports